import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './cons-type-donor-document.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsTypeDonorDocumentDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const consTypeDonorDocumentEntity = useAppSelector(state => state.consTypeDonorDocument.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="consTypeDonorDocumentDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.detail.title">ConsTypeDonorDocument</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{consTypeDonorDocumentEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.code">Code</Translate>
            </span>
          </dt>
          <dd>{consTypeDonorDocumentEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.name">Name</Translate>
            </span>
          </dt>
          <dd>{consTypeDonorDocumentEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.nameAr">Name Ar</Translate>
            </span>
          </dt>
          <dd>{consTypeDonorDocumentEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.nameEn">Name En</Translate>
            </span>
          </dt>
          <dd>{consTypeDonorDocumentEntity.nameEn}</dd>
          <dt>
            <span id="folderName">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.folderName">Folder Name</Translate>
            </span>
          </dt>
          <dd>{consTypeDonorDocumentEntity.folderName}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.status">Status</Translate>
            </span>
          </dt>
          <dd>{consTypeDonorDocumentEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/cons-type-donor-document" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/cons-type-donor-document/${consTypeDonorDocumentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConsTypeDonorDocumentDetail;
